import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import { getAllQuestions, clearCurrentQuestion } from "../reducers/questions";
import { getScore } from "../reducers/auth";
import {Link} from "react-router-dom";
import Hero from '../components/hero.js';

function mapStateToProps(state) {
	return {questions: state.questions, auth: state.auth};
}

const mapDispatchToProps = dispatch => bindActionCreators({
	getAllQuestions,
	getScore,
	clearCurrentQuestion
}, dispatch)

const ChallengeBlock = (props) => {
	if(props.Completed){
		return (
			<div>
				<div className={"challenge__item active"}>
					<p>{props.Title} (Done)</p>

					<img src={require("../img/arrow.png")} alt=""/>
				</div>
			</div>
		)
	}

	return (
		<Link to={'/challenges/' + props.Id}>
			<div className={"challenge__item"}>
				<p>{props.Title}</p>

				<img src={require("../img/arrow.png")} alt=""/>
			</div>
		</Link>
	)
};

class Challenges extends Component {
	state  = {
		showRegistration: false,
		showFriendChallenge: false
	}

	componentDidMount() {
		this.props.clearCurrentQuestion();
		this.props.getAllQuestions();
		this.props.getScore();
	}

	render() {
		if(!this.props.questions.questions)
			return null

		return (
			<main className="">
				<Hero {...this.props} />

				<section className="content bg-color_gradient paddingLeft-120 shadow-top">
					<div className="row">
						<div className="col-12 d-flex justify-content-between">
							<h3 className="blue-text bold">Your Challenges</h3>

							{this.props.auth.user.EntriesCount === 25 && <p className={"your-score"}><span>Your Score: </span>{this.props.auth.user.Score}</p>}
						</div>

						{this.props.questions.questions.map((item, key) => {
							return (
								<div key={key} className="col-12 col-md-6 col-lg-4">
									<div className="challenge">
										<p className={"title" + (key === 2 ? ' red' : (key === 1 ? ' medium' : ''))}>{item.Title}</p>

										{item.Questions.map((question, k) => {
											return (
												<div key={k} className={"challenge__block"}>
													<ChallengeBlock {...question} />
												</div>
											)
										})}
									</div>
								</div>
							)
						})}

					</div>
				</section>
			</main>
		);
	}
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Challenges);